/**
 * Unified API Client
 * Combines all domain-specific API clients into a single facade
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SessionAPI } from "./session-api";
import { ChatAPI } from "./chat-api";
import { OfferAPI } from "./offer-api";
import { BrandAPI } from "./brand-api";
import { RewardAPI } from "./reward-api";
import { AuthAPI } from "./auth-api";
import { RedemptionAPI } from "./redemption-api";
/**
 * Main API Client - Facade for all domain APIs
 */
export class APIClient {
    constructor(config, env) {
        // Initialize all domain APIs
        this._sessionAPI = new SessionAPI(config, env);
        this._chatAPI = new ChatAPI(config, env);
        this._offerAPI = new OfferAPI(config, env);
        this._brandAPI = new BrandAPI(config, env);
        this._rewardAPI = new RewardAPI(config, env);
        this._authAPI = new AuthAPI(config, env);
        this._redemptionAPI = new RedemptionAPI(config, env);
    }
    // ===== API Access (for services) =====
    get brandAPI() {
        return this._brandAPI;
    }
    get offerAPI() {
        return this._offerAPI;
    }
    get redemptionAPI() {
        return this._redemptionAPI;
    }
    // ===== User Info =====
    getUserEmail() {
        return this._sessionAPI.getUserEmail();
    }
    getUserId() {
        return this._sessionAPI.getUserId();
    }
    // ===== Session Management =====
    // Note: Sessions are now auto-created by the API on first message
    // No manual session creation needed
    getUserSessions() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._sessionAPI.getUserSessions();
        });
    }
    getConversation(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._sessionAPI.getConversation(sessionId);
        });
    }
    deleteSession(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._sessionAPI.deleteSession(sessionId);
        });
    }
    // ===== Chat & Messaging =====
    sendMessage(sessionId, message, onChunk, onComplete, onError) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._chatAPI.sendMessage(sessionId, message, onChunk, onComplete, onError);
        });
    }
    // ===== Offers =====
    fetchOfferDetails(offerCode, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._offerAPI.fetchOfferDetails(offerCode, sessionId);
        });
    }
    fetchOffersByBrandId(brandId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._offerAPI.fetchOffersByBrandId(brandId, token);
        });
    }
    // ===== Brands =====
    fetchBrandsByCategoryId(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._brandAPI.fetchBrandsByCategoryId(categoryId);
        });
    }
    // ===== Rewards & Redemption =====
    fetchRewardBalances(walletAddress, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._rewardAPI.fetchRewardBalances(walletAddress, token);
        });
    }
    fetchSwapAmount(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._rewardAPI.fetchSwapAmount(payload, token);
        });
    }
    // ===== Authentication =====
    meProtocolLogin(email, walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._authAPI.meProtocolLogin(email, walletAddress);
        });
    }
}
